var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReuseBoxes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 4.0013C16.5348 4.0013 3.99988 16.538 3.99988 32.0002C3.99988 47.4623 16.5348 59.999 32 59.999C47.4652 59.999 60.0001 47.4623 60.0001 32.0002C60.0001 16.538 47.4652 4.0013 32 4.0013ZM0.00012207 32.0002C0.00012207 14.3252 14.3281 -0.000976562 32 -0.000976562C49.6719 -0.000976562 63.9999 14.3252 63.9999 32.0002C63.9999 49.6751 49.6719 64.0013 32 64.0013C14.3281 64.0013 0.00012207 49.6751 0.00012207 32.0002Z",
    fill: "#FF0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2667 18.5684H32.9467V28.755L34.2 27.875L35.4533 28.755L36.7067 27.875L37.96 28.755L39.2133 27.875L40.4667 28.755V18.5684H42.76C43.1908 18.568 43.6175 18.6526 44.0156 18.8173C44.4137 18.982 44.7755 19.2236 45.0801 19.5283C45.3848 19.8329 45.6263 20.1946 45.791 20.5927C45.9558 20.9908 46.0403 21.4175 46.04 21.8483V42.2484C46.0403 42.6792 45.9558 43.1059 45.791 43.504C45.6263 43.9021 45.3848 44.2638 45.0801 44.5684C44.7755 44.8731 44.4137 45.1147 44.0156 45.2794C43.6175 45.4441 43.1908 45.5287 42.76 45.5284H21.24C20.8092 45.5287 20.3825 45.4441 19.9844 45.2794C19.5863 45.1147 19.2246 44.8731 18.9199 44.5684C18.6153 44.2638 18.3737 43.9021 18.209 43.504C18.0443 43.1059 17.9596 42.6792 17.96 42.2484V21.8483C17.9596 21.4175 18.0443 20.9908 18.209 20.5927C18.3737 20.1946 18.6153 19.8329 18.9199 19.5283C19.2246 19.2236 19.5863 18.982 19.9844 18.8173C20.3825 18.6526 20.8092 18.568 21.24 18.5684H21.2667Z",
    fill: "#123660"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1153 55.638L8.03793 11.286L10.8741 8.46387L54.9514 52.8159L52.1153 55.638Z",
    fill: "#FF0033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReuseBoxes);
export default __webpack_public_path__ + "static/media/icon-reuse-boxes.73833018ca5b83f6a150545b928e5139.svg";
export { ForwardRef as ReactComponent };